var StacktraceFormatterViewModel = function () {
    var self = this;

    self.init = function(id) {
        fetch('/tools/stack-trace-formatter/' + id + '/fetch')
        .then(response => response.text())
        .then(content => {
            try {
                self.input(decodeURIComponent(content));
            } catch (e) {
                // handle error if necessary
            }
        });
    }

    self.input = ko.observable();
    self.input.subscribe(function (newValue) {
        self.content(newValue);
        if (newValue) {
            new netStack('.stacktrace', {
                prettyprint: true
            });
        }
    });

    self.minimizeInput = ko.pureComputed(function(){
        return self.input() !== "";
    });

    self.content = ko.observable("");

    self.shareLink = ko.observable("");

    function watermarkImage(elemImage, text) {
        // Create test image to get proper dimensions of the image.
        var testImage = new Image();
        testImage.onload = function() {
            var h = testImage.height + 5, w = testImage.width, img = new Image();
            // Once the image with the SVG of the watermark is loaded...
            img.onload = function() {
                // Make canvas with image and watermark
                var canvas = Object.assign(document.createElement('canvas'), { width: w, height: h });
                var ctx = canvas.getContext('2d');
                ctx.fillStyle = "#333";
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(testImage, 0, 0);
                ctx.drawImage(img, 0, 0);
                // If PNG can't be retrieved show the error in the console
                try {
                    elemImage.src = canvas.toDataURL('image/png');

                    var link = document.createElement("a");
                    document.body.appendChild(link);
                    link.download = "stacktrace_" + Math.floor(Date.now() / 1000) + ".png";
                    link.href = canvas.toDataURL("image/png");
                    link.target = '_blank'; link.click(); link.remove();

                    const ssButton = document.querySelector('#ssbutton');
                    ssButton.removeAttribute("disabled");
                    ssButton.querySelector('.label').textContent = 'Screenshot';
                    ssButton.querySelector('.spinner-border').classList.add('d-none');
                    document.querySelector('.screenshot-wrapper pre').classList.remove('overflow-hidden');
                }
                catch (e) {
                    console.error('Cannot watermark image with text:', { src: elemImage.src, text: text, error: e });
                }
            };
            // SVG image watermark (HTML of text at bottom right)
            img.src = 'data:image/svg+xml;base64,' + window.btoa('<svg xmlns="http://www.w3.org/2000/svg" height="' + h + '" width="' + w + '"><foreignObject width="100%" height="100%"><div xmlns="http://www.w3.org/1999/xhtml"><div style="position: absolute; right: 0; bottom: 0; font-family: Consolas; font-size: 10px; color: #999; padding: 0.25em .5em; margin: 0 0.125em 0.125em 0;">' + text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") + '</div></div></foreignObject></svg>');
        }
        testImage.src = elemImage.src;
    }

    // Prevent from submiting form
    document.querySelectorAll('#cpybutton, #mrkdbutton, #sharebutton, #sharebutton-hide').forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
        });
    });

    // Copy to clipboard button
    var copyStacktrace = new ClipboardJS('#cpybutton', {
        text: function () {
            return document.querySelector('.stacktrace').innerText + '\n\n' + 'Formatted by https://st.elmah.io';
        }
    });
    copyStacktrace.on('success', function(e) {
        e.clearSelection();
        const cpyButton = new bootstrap.Tooltip(document.querySelector('#cpybutton'));
        cpyButton.show();
        setTimeout(() => cpyButton.hide(), 1000);
    });

    // Copy to clipboard for markdown button
    var mrkdStacktrace = new ClipboardJS('#mrkdbutton', {
        text: function () {
            return '```csharp\n' + document.querySelector('.stacktrace').innerText + '\n```' + '\n\n' + '[![](https://img.shields.io/badge/Formatted%20by-https%3A%2F%2Fst.elmah.io-%230da58e)](https://st.elmah.io)';
        }
    });
    mrkdStacktrace.on('success', function (e) {
        e.clearSelection();
        const mrkdButton = new bootstrap.Tooltip(document.querySelector('#mrkdbutton'));
        mrkdButton.show();
        setTimeout(() => mrkdButton.hide(), 1000);
    });

    // Share stack trace button
    document.querySelector('#sharebutton').addEventListener('click', function (e) {
        if (!self.shareLink()) {
            const shareButton = e.currentTarget;
            shareButton.setAttribute('disabled', true);
            shareButton.querySelector('.spinner-border').classList.remove('d-none');

            fetch("/tools/stack-trace-formatter/", {
                method: 'POST',
                headers: {
                    '__RequestVerificationToken': document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value'),
                },
                body: new URLSearchParams({
                    content: self.input()
                })
            })
            .then(response => response.json())
            .then(data => {
                shareButton.removeAttribute('disabled');
                shareButton.querySelector('.spinner-border').classList.add('d-none');

                if (data && data.id) {
                    window.history.replaceState({}, document.title, '/tools/stack-trace-formatter/' + data.id + '/');
                    self.shareLink(window.location.origin + '/tools/stack-trace-formatter/' + data.id + '/');
                    // show share popover
                    sharePopover.show();
                }
            });
        } else {
            // show share popover
            sharePopover.show();
        }
    });

    // Share button copy
    var shareStacktrace = new ClipboardJS('#popover-share-button', {
        text: function() {
            return document.querySelector('#popover-share-input').value;
        }
    });
    shareStacktrace.on('success', function (e) {
        e.clearSelection();
        document.querySelector('#popover-share-button').innerHTML = '<i class="fas fa-copy me-1"></i>Copied!';
        setTimeout(function () {
            sharePopover.hide();
        }, 1000);
    });

    // Hide popup on click outside
    document.body.addEventListener("click", function(e) {
        document.querySelectorAll('.card-stacktrace .card-footer .popover').forEach(function(popover) {
            if (!(e.target.id === 'sharebutton' || e.target.parentElement.id === 'sharebutton') && !e.target.closest('.popover')) {
                sharePopover.hide();
            }
        });
    });

    // Share popover
    const sharePopover = new bootstrap.Popover('#sharebutton', {
        trigger: 'manual',
        placement: 'bottom',
        container: '.card-stacktrace .card-footer',
        html: true,
        sanitize: false,
        content: `
            <div class="content-share">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control" id="popover-share-input" data-bind="textInput: self.shareLink()" readonly />
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" id="popover-share-button"><i class="fal fa-copy me-1"></i>Copy</button>
                    </div>
                </div>
            </div>`
    });

    document.querySelector('#sharebutton').addEventListener('shown.bs.popover', function () {
        const inputElement = document.querySelector('#popover-share-input');
        inputElement.value = window.location.href;
    });

    // Screenshot stacktrace button
    document.querySelector('#ssbutton').addEventListener('click', (e) => {
        e.preventDefault();

        const ssButton = e.currentTarget;
        ssButton.setAttribute("disabled", true);
        ssButton.querySelector('.label').textContent = 'Generating screenshot..';
        ssButton.querySelector('.spinner-border').classList.remove('d-none');

        const node = document.querySelector('.screenshot-wrapper pre');
        node.classList.add('overflow-hidden');

        domtoimage.toPng(node, { width: node.scrollWidth, height: node.scrollHeight })
            .then(function (dataUrl) {
                var image = new Image();
                image.src = dataUrl;
                watermarkImage(image, 'Formatted by https://st.elmah.io');
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
    });

    // Wrap text mode
    document.querySelector('#wrapText').addEventListener('change', (e) => {
        const cardStackPre = document.querySelector('.card-stacktrace pre');
        cardStackPre.classList.remove('pre-wrap');
        if (e.currentTarget.checked) {
            cardStackPre.classList.add('pre-wrap');
        }
    });

    self.shareToolbox = ko.pureComputed({
        read: function () {
            var url = encodeURIComponent(window.location.href),
                title = encodeURIComponent(document.title),
                description = encodeURIComponent(document.getElementsByName('description')[0].getAttribute('content'));

            return {
                facebook: 'https://www.facebook.com/sharer.php?u=' + url,
                twitter: 'https://x.com/intent/tweet?url=' + url + '&text=' + title,
                linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + url,
                email: 'mailto:?subject=' + title + '&body=' + description + ' Link: ' + url
            };
        },
        owner: this
    });
};

document.addEventListener("DOMContentLoaded", function () {
    var vm = new StacktraceFormatterViewModel();
    ko.applyBindings(vm, document.body);

    // Initialize init if ID is present
    var s = location.href.split('/');
    var last = s[s.length - 2];
    if (last && last !== '' && last.length === 32) {
        vm.init(last);
    }

    // Hljs more description
    const moreDescription = document.querySelector('.more-description');
    moreDescription.querySelectorAll('pre code.stacktrace').forEach((block) => {
        new netStack(block, {
            prettyprint: true
        });
    });

    moreDescription.querySelectorAll('pre code:not(.stacktrace)').forEach((block) => {
        hljs.highlightBlock(block);
    });
});